export const AppName = 'SplendidCRM';
export const AppVersion = '15.0.9027';

